import { createAction, props } from "@ngrx/store";
import { GetEnumRequest } from "../enumeration/enumeration.model";
import { Labels } from "src/app/app.models";

export enum DigitalPaymentActions {
  dpGetEnums = '[Digital Payment] dpGetEnums',
  dpGetEnumsSuccess = '[Digital Payment] dpGetEnumsSuccess',
  dpSendValidate = '[Digital Payment] dpSendValidate',
  dpSendValidateSuccess = '[Digital Payment] dpSendValidateSuccess',
  dpSendCommit = '[Digital Payment] dpSendCommit',
  dpSendCommitSuccess = '[Digital Payment] dpSendCommitSuccess'
}

export const DpGetEnums = createAction(
  DigitalPaymentActions.dpGetEnums,
  props<{ getEnumRequest: GetEnumRequest, endpoint: string, sendValidatePayload: any, transactionId: string, cmsLabels: Labels }>()
)

export const DpGetEnumsSuccess = createAction(
  DigitalPaymentActions.dpGetEnumsSuccess,
  props<{ getEnumsResponse: any, sendValidatePayload: any, transactionId: string, endpoint: string }>() // Todo: Tim: fix type
)

export const DpSendValidate = createAction(
  DigitalPaymentActions.dpSendValidate,
  props<{ sendValidatePayload: any, transactionId: string, endpoint: string }>() // Todo: Tim: fix type
)

export const DpSendValidateSuccess = createAction(
  DigitalPaymentActions.dpSendValidateSuccess,
  props<{ sendValidateResponse: any }>() // Todo: Tim: fix type
)

export const DpSendCommit = createAction(
  DigitalPaymentActions.dpSendCommit,
  props<{ transactionId: string | number, locale: string, endpoint: string }>()
)

export const DpSendCommitSuccess = createAction(
  DigitalPaymentActions.dpSendCommitSuccess,
  props<{sendCommitResponse: any}>() // Todo: Tim: fix types
)